import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import DataKeys from 'k8s/DataKeys'
import { emptyObj } from 'utils/fp'

export const leasePoliciesSelector = createSharedSelector(
  getDataSelector<DataKeys.LeasePolicies>(DataKeys.LeasePolicies),
  (leasePolicies) => {
    return leasePolicies.map((leasePolicy) => {
      return {
        ...leasePolicy,
      }
    })
  },
)

export const leasePoliciesByTenantIdSelector = createSharedSelector(
  leasePoliciesSelector,
  (policies) =>
    policies.reduce((accum, policy) => {
      return {
        ...accum,
        [policy.tenant_uuid]: policy,
      }
    }, emptyObj),
)

export const leasesSelector = createSharedSelector(
  getDataSelector<DataKeys.Leases>(DataKeys.Leases),
  (leases) => {
    return leases.map((lease) => {
      return {
        ...lease,
      }
    })
  },
)

export const leasesByVmIdSelector = createSharedSelector(leasesSelector, (leases) =>
  leases.reduce((accum, lease) => {
    return {
      ...accum,
      [lease.instance_uuid]: lease,
    }
  }, emptyObj),
)
